<script setup>
const y = ref(0)
const hideMono = useState('hideMono', () => false)
// Людина вимкнула збір у профілі — не показуємо зовсім
const user = useStrapiUser()

onMounted(() => {
  if (import.meta.client) {
    const { y: scrollY } = useWindowScroll()
    watch(scrollY, (val) => {
      y.value = val
    })
  }
})
</script>

<template>
  <div
    v-if="!hideMono && !user?.hideDonate"
    class="flex min-h-[156px] lg:min-h-[unset]"
  >
    <ClientOnly>
      <div class="relative w-full">
        <div
          :class="{ hide: y > 1000 }"
          class="lg:bottom-0 lg:left-[50%] lg:z-10 lg:fixed lg:flex lg:justify-end px-[10px] lg:px-0 py-[10px] w-full lg:w-full lg:max-w-[1330px] lg:max-w-screen lg:-translate-x-[50%] mono"
        >
          <LazyMyMono />
        </div>
      </div>
      <template #fallback>
        <div
          class="lg:hidden px-[10px] py-[10px] w-full"
          style="min-height: 156px"
        />
      </template>
    </ClientOnly>
  </div>
</template>

<style scoped>
.mono {
  transition: bottom 0.5s ease-in-out;
}

.mono.hide {
  bottom: -200px;
}
</style>
